import {
  OPEN_LONGIN_MODAL,
  CLOSE_LONGIN_MODAL,
  OPEN_SIGNUP_MODAL,
  CLOSE_SIGNUP_MODAL,
  OPEN_FORGOT_PASSWORD_MODAL,
  CLOSE_FORGOT_PASSWORD_MODAL,
  OPEN_REPORT_USER_MODAL,
  CLOSE_REPORT_USER_MODAL,
  OPEN_THANK_YOU_MODAL,
  CLOSE_THANK_YOU_MODAL,
  OPEN_SOCIAL_SHARE_MODAL,
  CLOSE_SOCIAL_SHARE_MODAL,
  OPEN_HEADER_MODAL,
  CLOSE_HEADER_MODAL,
  OPEN_MORE_FILTERS_MODAL,
  CLOSE_MORE_FILTERS_MODAL,
  ADMIN_COMMENT_MODAL_SHOW,
  ADMIN_COMMENT_MODAL_HIDE,
  ADMIN_HISTORY_MODAL_SHOW,
  ADMIN_HISTORY_MODAL_HIDE,
  OPEN_PAYMENT_MODAL,
  CLOSE_PAYMENT_MODAL,
  OPEN_FILTER_MODAL,
  CLOSE_FILTER_MODAL,
  OPEN_TRANSACTION_MODAL,
  CLOSE_TRANSACTION_MODAL,
  OPEN_TOTAL_PRICE_MODAL,
  CLOSE_TOTAL_PRICE_MODAL,
  OPEN_DELETE_USER_MODAL,
  CLOSE_DELETE_USER_MODAL,
  OPEN_FAILED_PAYOUT_OR_REFUND_MODAL,
  CLOSE_FAILED_PAYOUT_OR_REFUND_MODAL,
  OPEN_SIMPLIFIED_FILTERS_MODAL,
  CLOSE_SIMPLIFIED_FILTERS_MODAL
} from '../constants';
import { toggleClose } from './Menu/toggleControl';
import { initialize, change } from 'redux-form';
import { calculateTotalPrice } from '../helpers/calculateTotalPrice';

export function openLoginModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_LONGIN_MODAL,
      isLoginModalOpen: true,
      isSignupModalOpen: false,
      isForgotPasswordOpen: false
    });
    dispatch(toggleClose());
  };

}

export function closeLoginModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_LONGIN_MODAL,
      isLoginModalOpen: false
    });
    dispatch(toggleClose());
  };

}


export function openSignupModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_SIGNUP_MODAL,
      isSignupModalOpen: true,
      isLoginModalOpen: false
    });
  };

}

export function closeSignupModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_SIGNUP_MODAL,
      isSignupModalOpen: false
    });
  };

}

export function openForgotPasswordModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_FORGOT_PASSWORD_MODAL,
      isForgotPasswordOpen: true,
      isLoginModalOpen: false
    });
  };

}

export function closeForgotPasswordModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_FORGOT_PASSWORD_MODAL,
      isForgotPasswordOpen: false
    });
  };

}

export function openReportUserModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_REPORT_USER_MODAL,
      payload: {
        isReportUserModalOpen: true,
      }
    });
  };

}

export function closeReportUserModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_REPORT_USER_MODAL,
      payload: {
        isReportUserModalOpen: false
      }
    });
  };

}

export function openThankYouModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_THANK_YOU_MODAL,
      payload: {
        isThankYouModalOpen: true,
        isReportUserModalOpen: false
      }
    });
  };

}

export function closeThankYouModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_THANK_YOU_MODAL,
      payload: {
        isThankYouModalOpen: false,
      }
    });
  };

}

export function openSocialShareModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_SOCIAL_SHARE_MODAL,
      payload: {
        isSocialShareModal: true,
      }
    });
  };

}

export function closeSocialShareModal() {

  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_SOCIAL_SHARE_MODAL,
      payload: {
        isSocialShareModal: false,
      }
    });
  };
}

export function openHeaderModal(modalType) {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_HEADER_MODAL,
      payload: {
        modalType,
        actionValue: true
      }
    });
  };
}

export function closeHeaderModal(modalType) {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_HEADER_MODAL,
      payload: {
        modalType,
        actionValue: false
      }
    });
  };
}

export function openMoreFiltersModal() {

  return (dispatch, getState) => {
    dispatch({
      type: OPEN_MORE_FILTERS_MODAL,
      payload: {
        isMoreFiltersModal: true,
      },
    });
  }
}

export function closeMoreFiltersModal() {

  return async (dispatch, getState) => {
    dispatch({
      type: CLOSE_MORE_FILTERS_MODAL,
      payload: {
        isMoreFiltersModal: false,
      }
    });
  };

}

export function openTotalPriceModal(listingData, listBlockedDates, serviceFees, base, rates) {
  const calculatedValues = calculateTotalPrice({ listingData, listBlockedDates, serviceFees, base, rates });
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_TOTAL_PRICE_MODAL,
      payload: {
        isTotalPriceModal: true,
        calculatedValues: calculatedValues,
      },
    });
  };
}

export function closeTotalPriceModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_TOTAL_PRICE_MODAL,
      payload: {
        isTotalPriceModal: false,
      }
    });
  };
}

export function openCommentModal(listId) {

  return (dispatch, getState) => {

    dispatch({
      type: ADMIN_COMMENT_MODAL_SHOW,
      payload: {
        commentModal: true,
        listId: listId
      }
    });
  };

}

export function closeCommentModal() {

  return (dispatch, getState) => {
    dispatch({
      type: ADMIN_COMMENT_MODAL_HIDE,
      payload: {
        commentModal: false,
      }
    });
    dispatch(initialize('CommentForm', ''));
  };

}

export function openHistoryModal(listingHistory) {

  return (dispatch, getState) => {

    dispatch({
      type: ADMIN_HISTORY_MODAL_SHOW,
      payload: {
        historyModal: true,
        listingHistory
      }
    });
  };

}

export function closeHistoryModal() {

  return (dispatch, getState) => {
    dispatch({
      type: ADMIN_HISTORY_MODAL_HIDE,
      payload: {
        historyModal: false,
      }
    });
  };

}

export function openPaymentModal() {

  return (dispatch, getState) => {

    dispatch({
      type: OPEN_PAYMENT_MODAL,
      payload: {
        paymentModal: true,
      }
    });
  };

}

export function closePaymentModal() {

  return (dispatch, getState) => {

    dispatch({
      type: CLOSE_PAYMENT_MODAL,
      payload: {
        paymentModal: false,
      }
    });
  }

};

export function applyPaymentModal({ checkIn, checkOut, guests, currentFormValues }) {

  return async (dispatch, getState) => {

    await Promise.all([
      dispatch(change('PaymentForm', 'guests', guests)),
      dispatch(change('PaymentForm', 'checkIn', checkIn)),
      dispatch(change('PaymentForm', 'checkOut', checkOut)),
      dispatch(change('PaymentForm', 'discount', currentFormValues?.discount)),
      dispatch(change('PaymentForm', 'discountType', currentFormValues?.discountType)),
      dispatch(change('PaymentForm', 'guestServiceFee', currentFormValues?.guestServiceFee)),
      dispatch(change('PaymentForm', 'hostServiceFee', currentFormValues?.hostServiceFee)),
      dispatch(change('PaymentForm', 'total', currentFormValues?.total)),
      dispatch(change('PaymentForm', 'totalValue', currentFormValues?.totalValue)),
      dispatch(change('PaymentForm', 'priceForDays', currentFormValues?.priceForDays)),
      dispatch(change('PaymentForm', 'isSpecialPriceAssigned', currentFormValues?.isSpecialPriceAssigned)),
      dispatch(change('PaymentForm', 'bookingSpecialPricing', currentFormValues?.bookingSpecialPricing)),
      dispatch(change('PaymentForm', 'isSpecialPriceAverage', currentFormValues?.isSpecialPriceAverage)),
      dispatch(change('PaymentForm', 'dayDifference', currentFormValues?.dayDifference)),
      dispatch(change('PaymentForm', 'hostServiceFeeType', currentFormValues?.hostServiceFeeType)),
      dispatch(change('PaymentForm', 'hostServiceFeeValue', currentFormValues?.hostServiceFeeValue)),
      dispatch(change('PaymentForm', 'guestServiceFeeType', currentFormValues?.guestServiceFeeType)),
      dispatch(change('PaymentForm', 'guestServiceFeeValue', currentFormValues?.guestServiceFeeValue)),
      dispatch(change('PaymentForm', 'taxPrice', currentFormValues?.taxPrice)),
      dispatch(change('BookingForm', 'guests', guests)),
      dispatch(change('BookingForm', 'checkIn', checkIn)),
      dispatch(change('BookingForm', 'checkOut', checkOut)),
      dispatch(change('BookingForm', 'startDate', checkIn)),
      dispatch(change('BookingForm', 'endDate', checkOut)),
      dispatch(change('PaymentForm', 'isHostServiceEligible', currentFormValues?.hostServiceFee > currentFormValues?.priceForDays ? true : false)),
    ])

    await dispatch({
      type: CLOSE_PAYMENT_MODAL,
      payload: {
        paymentModal: false,
      }
    });
  };

}

export function openFilterModal() {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_FILTER_MODAL,
      payload: {
        filterModal: true,
      }
    });
  };
}

export function closeFilterModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_FILTER_MODAL,
      payload: {
        filterModal: false,
      }
    });
  };
}

export function openTransactionModal() {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_TRANSACTION_MODAL,
      payload: {
        transactionModal: true,
      }
    });
  };
}

export function closeTransactionModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_TRANSACTION_MODAL,
      payload: {
        transactionModal: false,
      }
    });
  };
}

export function openDeleteUserModal() {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_DELETE_USER_MODAL,
      payload: {
        openDeleteModal: true,
      }
    });
  };
}

export function closeDeleteUserModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_DELETE_USER_MODAL,
      payload: {
        openDeleteModal: false,
      }
    });
  };
}

export function openFailedPayoutOrRefundModal(id, type) {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_FAILED_PAYOUT_OR_REFUND_MODAL,
      payload: {
        isFailedPayoutOrRefundOpen: true,
        reservationId: id,
        type: type
      }
    });
  };
}

export function closeFailedPayoutOrRefundModal() {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_FAILED_PAYOUT_OR_REFUND_MODAL,
      payload: {
        isFailedPayoutOrRefundOpen: false
      }
    });
  };
}

export function openSimplifiedFiltersModal() {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_SIMPLIFIED_FILTERS_MODAL,
      payload: {
        isSimplifiedFiltersModal: true,
      },
    });
  }
}

export function closeSimplifiedFiltersModal() {
  return async (dispatch, getState) => {
    dispatch({
      type: CLOSE_SIMPLIFIED_FILTERS_MODAL,
      payload: {
        isSimplifiedFiltersModal: false,
      }
    });
  };
}